export default __webpack_public_path__ + "static/media/MBCorpoATitleOffice-Regular.7392d922.ttf";